import React, { useState } from 'react';

function PaymentDetails({ onSubmit }) {
  const [form, setForm] = useState({
    nameOnAccount: '',
    accountNumber: '',
    bankName: '',
    ifsc: '',
    upi: '',
    paymentMethod: 'bank',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (onSubmit) onSubmit(form);
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 440, margin: '32px auto', padding: 24, background: '#f6f8fa', borderRadius: 8, boxShadow: '0 2px 8px #eee' }}>
      <h2 style={{ marginBottom: 20 }}>Payment Details</h2>
      <div style={{ marginBottom: 18 }}>
        <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Payment Method</label>
        <select
          name="paymentMethod"
          value={form.paymentMethod}
          onChange={handleChange}
          style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc', fontSize: 16 }}
        >
          <option value="bank">Bank Transfer</option>
          <option value="upi">UPI</option>
        </select>
      </div>
      {form.paymentMethod === 'bank' && (
        <>
          <div style={{ marginBottom: 14 }}>
            <label htmlFor="nameOnAccount" style={{ display: 'block', marginBottom: 6 }}>Name on Account</label>
            <input
              type="text"
              id="nameOnAccount"
              name="nameOnAccount"
              value={form.nameOnAccount}
              onChange={handleChange}
              required
              style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
            />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label htmlFor="accountNumber" style={{ display: 'block', marginBottom: 6 }}>Account Number</label>
            <input
              type="text"
              id="accountNumber"
              name="accountNumber"
              value={form.accountNumber}
              onChange={handleChange}
              required
              style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
            />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label htmlFor="bankName" style={{ display: 'block', marginBottom: 6 }}>Bank Name</label>
            <input
              type="text"
              id="bankName"
              name="bankName"
              value={form.bankName}
              onChange={handleChange}
              required
              style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
            />
          </div>
          <div style={{ marginBottom: 18 }}>
            <label htmlFor="ifsc" style={{ display: 'block', marginBottom: 6 }}>IFSC Code</label>
            <input
              type="text"
              id="ifsc"
              name="ifsc"
              value={form.ifsc}
              onChange={handleChange}
              required
              style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
            />
          </div>
        </>
      )}
      {form.paymentMethod === 'upi' && (
        <div style={{ marginBottom: 18 }}>
          <label htmlFor="upi" style={{ display: 'block', marginBottom: 6 }}>UPI ID</label>
          <input
            type="text"
            id="upi"
            name="upi"
            value={form.upi}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
          />
        </div>
      )}
      <button type="submit" style={{ padding: '10px 24px', borderRadius: 4, background: '#1976d2', color: '#fff', border: 'none', fontWeight: 600, cursor: 'pointer' }}>
        Save Payment Details
      </button>
      {submitted && (
        <div style={{ marginTop: 20, color: '#388e3c', fontWeight: 500 }}>
          Payment details saved!
        </div>
      )}
    </form>
  );
}

export default PaymentDetails;
